export const BASE_URL = import.meta.env.BASE_URL;

/** `BASE_URL` without its trailing slash — the shape React Router's `basename` expects. */
export const BASE_PATH = BASE_URL.replace(/\/$/, "");
